/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkPillar {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkPillar.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkPillar>): WellArchitectedFrameworkPillar {
        let obj = Object.assign(new WellArchitectedFrameworkPillar(), model);
        WellArchitectedFrameworkPillar.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkPillar>): WellArchitectedFrameworkPillar {
        if (!model) return null;
        return WellArchitectedFrameworkPillar.newInstance(<WellArchitectedFrameworkPillar> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkPillar) {
        if (!obj) return;

        models.WellArchitectedFrameworkPillar.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkPillar): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkPillar.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.questions) {
            for (let val of this.questions) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
    }

    /**
     * Framework id for the Pillar
     */
    framework_id: string;

    /**
     * Unique Id of the Pillar
     */
    pillar_id: string;

    /**
     * Unique Id of pillar
     */
    hyperscaler_pillar_id: string;

    /**
     * Name of Pillar for the Framework
     */
    pillar: string;

    /**
     * Description of the Pillar
     */
    description: string;

    /**
     * Icon for the pillar
     */
    icon: string;

    questions: Array<models.RecordIdentity>;

}
